module.exports = __webpack_public_path__ + "static/media/web-dev.0632f268.svg";